<template>
  <div class="tooltip" :style="pos()" @click="$event.stopPropagation()">
    <div class="control">
      <slot name="tooltip-header-control"></slot>
    </div>
    <div class="header">
      <div v-html="props.header"></div>
    </div>
    <div class="content" :class="{ 'cols-2': (props.tooltipPosition.width !== '380px')}" v-html="props.content"></div>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue'
  const props = defineProps({ 
    tooltipPosition : Object,
    header: String,
    content:String
    });

  function pos() {
    return {
      ...props.tooltipPosition
    }
  }
</script>

<style scoped>
.tooltip {
  position: fixed;
  z-index: 5;
  display: flex;
  flex-direction: column;
  padding: 0 2px 8px 8px;
  overflow: hidden;
  user-select: none;
  background: #e9e8d2;
  border: 1px solid #EBF5FF;
  border-radius: 5px;
  box-shadow: 0px 0px 20px -5px black;
  font-size: 12px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.header {
  display: grid;
  grid-template-columns: max-content auto;
  margin: 12px 5px 0 5px;
  font-weight: bold;
}
.control {
  justify-self: end;
}
.content {
  margin: 5px;
}
.content.cols-2 {
  column-count: 2;
}
::v-deep(.content ol){
  margin-top: 0px;
        }
::v-deep(.content ul li){
  margin-left: -24px;
        }
::v-deep(.content ol li){
  margin-left: -24px;
        }
</style>